import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GateHausLogo from '../components/GateHausLogo';

const LoginPage = () => {
  const { startLogin } = useAuth();
  const location = useLocation();
  const handleLogin = async () => {
    await startLogin(location.state?.from || '/dashboard');
  };

  return (
    <div className="full-centre">
      <div className="card auth-form">
        <GateHausLogo stacked size={44} />
        <h2>Continue to Gate.haus</h2>
        <p style={{ color: 'var(--gray)' }}>
          Sign in securely with the Gate.haus login to access your dashboard.
        </p>
        <button className="primary-button" type="button" onClick={handleLogin}>
          Login with Gate.haus
        </button>
        <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
          Need an account? <Link to="/register">Join Gate.haus</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
